<template>
  <VTextField
    v-model="emailInput"
    class="ns-email flex-column"
    name="email"
    validate-on-blur
    maxlength="320"
    :label="label"
    :rules="[isEmailValid]"
    :disabled="disabled"
    @blur="validateEmail(emailInput)"
  />
</template>

<script>
import { VTextField } from 'vuetify/lib';
export default {
  name: 'NsEmail',
  components: {
    VTextField,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    /**
     * This is the Label of the input component.
     * Example: "Email Address:"
     * For local translations of this for a variety of locales, see:
     * https://nuskin.atlassian.net/wiki/spaces/SLE/pages/379682861/Standard+Email+Component+Translations
     */
    label: {
      type: String,
      required: true,
    },
    /**
     * This is the error message for the input component. It will not
     * actually be displayed unless the error state is reached.
     * Example: "Invalid e-mail"
     * For local translations, see the link above.
     */
    invalidEmailText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      emailInput: this.value,
      isEmailValid: true,
    };
  },
  watch: {
    emailInput() {
      this.$emit('input', this.emailInput.toLowerCase().trim());
    },
    value(newValue) {
      this.emailInput = newValue;
    },
  },
  methods: {
    validateEmail(value) {
      const pattern = /^[\s]*[A-Za-z0-9!#$%&*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?[\s]*$/;
      if (pattern.test(value) === true) {
        this.isEmailValid = true;
      } else {
        this.returnErrorState();
        this.isEmailValid = this.invalidEmailText;
      }
    },
    returnErrorState() {
      this.$emit('error-state', {
        invalidEmailText: this.invalidEmailText,
        isValid: false,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/vuetifyOverrides";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";

.ns-email {
  font-family: map.get(typographyVariables.$typography, font-family-primary);
  position: relative;
}
</style>
